import React from 'react';

// project-imports
import "./stencil-box.css";

const StencilBox = ({ text, width, height, backgroundColor, color, display, className, borderRadius }) => {
    const styles = {
        width: width || '',
        height: height || '100px',
        backgroundColor: backgroundColor || '#eee',
        color: color || '#000',
        display: display || 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: " 1px solid #F5F5F5",
        fontFamily: 'Arial, sans-serif',
        fontSize: '1.2em',
        textAlign: 'center',
        borderRadius: borderRadius || "none",
    };

    return (<span className={`stencil-box ` + className} style={styles}>{text}</span>);
};

export default StencilBox;